import { LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP } from 'utils/fieldConstants';
import { ComparatorsDropdownProps } from '../types';
import { isCatalog } from '../../../utils/isCatalog';

export const withRegexComparators = (
  { esIndex, isRegexUsageAllowed, regexTypeComparators }: ComparatorsDropdownProps,
  field?: string,
) =>
  !isCatalog(esIndex) &&
  isRegexUsageAllowed &&
  LIST_MEMBERSHIP !== field &&
  USER_LIST_MEMBERSHIP !== field
    ? regexTypeComparators
    : [];
